import axios from "axios";
import { URL_BACKEND_APP } from "../App.constants";

const url_api = axios.create({
  baseURL: URL_BACKEND_APP + "/eleve",
});
const url_api_ponctualite = axios.create({
  baseURL: URL_BACKEND_APP + "/ponctualite_eleve",
});
const url_api_promotion = axios.create({
  baseURL: URL_BACKEND_APP + "/promotion",
});

const ELEVE = {
  create: (data, token) => {
    return url_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return url_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return url_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return url_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return url_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return url_api.get(`/active.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return url_api.get(`/desactive.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
const PROMOTION = {
  create: (data, token) => {
    return url_api_promotion.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return url_api_promotion.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return url_api_promotion.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return url_api_promotion.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updateElevePromotion: (id1, id2, data1, data2, token) => {
    let url1 = url_api.put("/update.php?id=" + id1, data1, {
      headers: { Authorization: `Bearer ${token}` },
    });
    let url2 = url_api_promotion.put("/update.php?id=" + id2, data2, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return Promise.all([url1, url2]);
  },

  delete: (id, token) => {
    return url_api_promotion.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return url_api_promotion.get(`/active.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return url_api_promotion.get(`/desactive.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
const PONCTUALITE = {
  create: (data, token) => {
    return url_api_ponctualite.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return url_api_ponctualite.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return url_api_ponctualite.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return url_api_ponctualite.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return url_api_ponctualite.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export const API_ELEVE = { ELEVE, PONCTUALITE, PROMOTION };
